import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Card } from '../../../../../../packages/utx-access-client/src/react';

export interface CancelCardModalProps {
  onLayout: (event: any) => void;
}

export enum CancelCardStackRoutes {
  Main = 'main',
  Confirm = 'confirm',
  Placed = 'placed'
}

export type CancelCardStackParamList = {
  [CancelCardStackRoutes.Main]: CancelCardModalProps & {
    account: string;
    tab?: number;
    onData: (data: any) => void;
    record?: any;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
  };
  [CancelCardStackRoutes.Confirm]: CancelCardModalProps & {
    account: string;
    tab?: number;
    record?: any;
    data: any;
    func?: (data: any, onSuccess?: (data: any) => void, onError?: (error: any) => void) => void;
    onReturnData?: (data: any) => void;
    refresh?: () => void;
    onChangeView?: () => void;
  };
  [CancelCardStackRoutes.Placed]: CancelCardModalProps & {
    account: string;
    tab?: number;
    record?: any;
    data?: any;
    returnData?: any;
    refresh?: () => void;
  };
};

export type CancelCardStackScreenProps<Screen extends keyof CancelCardStackParamList> = NativeStackScreenProps<
  CancelCardStackParamList,
  Screen
>;
